import { render, staticRenderFns } from "./TaxTypeModal.vue?vue&type=template&id=775a9aa1"
import script from "./TaxTypeModal.vue?vue&type=script&lang=js"
export * from "./TaxTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775a9aa1')) {
      api.createRecord('775a9aa1', component.options)
    } else {
      api.reload('775a9aa1', component.options)
    }
    module.hot.accept("./TaxTypeModal.vue?vue&type=template&id=775a9aa1", function () {
      api.rerender('775a9aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/TaxTypeModal.vue"
export default component.exports